import SidebarGroup from "../sidebarGroup"
import useLayout from "hooks/useLayout"
import SidebarRow from "../SidebarRow"
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg'
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg'
import { ReactComponent as HistoryIcon } from 'assets/icons/restore.svg'
import RightSidebar from "./RightSidebar"
import { useTranslation } from "react-i18next"
import useAccess from "@/hooks/useAccess"
import useCustomers from "@/hooks/useCustomers"
import { AccessRole } from "@/types"
import { useState } from "react"

interface RightSidebarCustomerProps {
    className?: string;
    children?: React.ReactNode;
    storageId?: string;
    customerId?: string;
}

const RightSidebarCustomer: React.FC<RightSidebarCustomerProps> = ({ className, children, storageId, customerId }) => {

    const { t } = useTranslation()
    
    const {
        limitToRoles
    } = useAccess({ storageId: storageId || '' })

    const {
        customer,
        restoreCustomerAsync,
        isRestoring
    } = useCustomers({ storageId, customerId })

    const {
        openDialog,
        addToast
    } = useLayout()

    const [isRestoringState, setIsRestoringState] = useState(false)

    const handleDeleteClick = () => {
        openDialog(`delete_customer`)
    }

    const handleRestoreClick = async () => {
        if (!storageId || !customerId) return
        setIsRestoringState(true)
        try {
            await restoreCustomerAsync({
                storageId,
                customerId
            })
            addToast({
                text: t('customerRestored'),
                colorScheme: 'green'
            })
        } catch (error) {
            addToast({
                text: t('failedToRestore'),
                colorScheme: 'red'
            })
        } finally {
            setIsRestoringState(false)
        }
    }

    // Return the sidebar component.
    return (
        <>
            <RightSidebar storageId={storageId}>
                <SidebarRow 
                    text={t('buttonViewHistory')} 
                    style={`border`} 
                    onClick={() => openDialog('customer_history')}
                    icon={<HistoryIcon />}
                />
                {limitToRoles([AccessRole.OWNER, AccessRole.EDITOR]) &&
                    <SidebarGroup title={t('menuCustomerActions')} allwaysOpen={true}>
                        {!customer?.isDeleted && (
                            <>
                                <SidebarRow 
                                    to={`/storage/customers/${customerId}/edit`} 
                                    text={t('buttonEdit')} 
                                    icon={<EditIcon />} 
                                    style={`border`} 
                                />
                                <SidebarRow 
                                    onClick={handleDeleteClick} 
                                    text={t('buttonDelete')} 
                                    icon={<DeleteIcon />} 
                                    style={`border`} 
                                />
                            </>
                        )}
                        {customer?.isDeleted && (
                            <SidebarRow 
                                onClick={handleRestoreClick} 
                                text={isRestoring || isRestoringState ? t('restoringItem') : t('restoreCustomer')} 
                                style={`border`} 
                            />
                        )}
                    </SidebarGroup>
                }
            </RightSidebar>
        </>
    )
}

export default RightSidebarCustomer

